export default __webpack_public_path__ + "static/window-shopper-5c3fef0d1b3046f99b6951ea65d51f09.jpg";